// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane_FWBQu {
    border: 1px solid var( --color-base200 );
    border-radius: 8px;
    background: #FFFFFF;
    min-width: 175px;
    box-shadow:0px 0px 1px rgba(41, 50, 61, 0.32), 0px 8px 16px rgba(41, 50, 61, 0.12);
}

.flex_MIYwm {
    padding: 8px;
    align-items : center;
}

.text_LD1TU {
    align-self : center;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes-graphs/lib/viewers/PieRolloverCard.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kFAAkF;AACtF;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".pane {\n    border: 1px solid var( --color-base200 );\n    border-radius: 8px;\n    background: #FFFFFF;\n    min-width: 175px;\n    box-shadow:0px 0px 1px rgba(41, 50, 61, 0.32), 0px 8px 16px rgba(41, 50, 61, 0.12);\n}\n\n.flex {\n    padding: 8px;\n    align-items : center;\n}\n\n.text {\n    align-self : center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `pane_FWBQu`,
	"flex": `flex_MIYwm`,
	"text": `text_LD1TU`
};
export default ___CSS_LOADER_EXPORT___;
